import $ from "jquery";

function init() {
    $(".angular-search-result").each(function () {
        const el = $(this);
        import("angular").then(function (angular) {
            import("./searchApp").then(function () {
                angular.element(el).ready(() => {
                    angular.bootstrap(el, ["searchApp"]);
                });
            });
        });
    });
}

export default {
    init,
};
